export type OrderWordItem = { sourceIndex: number; text: string };

export function removeOrderWord(
  workspace: readonly OrderWordItem[],
  sourceIndex: number,
): OrderWordItem[] {
  return workspace.filter((item) => item.sourceIndex !== sourceIndex);
}

export function toggleOrderWord(
  workspace: readonly OrderWordItem[],
  item: OrderWordItem,
): OrderWordItem[] {
  return workspace.some((entry) => entry.sourceIndex === item.sourceIndex)
    ? removeOrderWord(workspace, item.sourceIndex)
    : [...workspace, item];
}

export function insertOrderWord(
  workspace: readonly OrderWordItem[],
  item: OrderWordItem,
  index: number,
): OrderWordItem[] {
  if (workspace.some((entry) => entry.sourceIndex === item.sourceIndex))
    return [...workspace];
  const result = [...workspace];
  result.splice(Math.max(0, Math.min(index, result.length)), 0, item);
  return result;
}

export function removeLastOrderWord(workspace: readonly OrderWordItem[]) {
  if (workspace.length === 0) return { item: null, workspace: [] };
  return {
    item: workspace[workspace.length - 1]!,
    workspace: workspace.slice(0, -1),
  };
}

export function reorderOrderWords(
  workspace: readonly OrderWordItem[],
  fromIndex: number,
  toIndex: number,
): OrderWordItem[] {
  if (
    fromIndex < 0 ||
    fromIndex >= workspace.length ||
    toIndex < 0 ||
    toIndex >= workspace.length
  )
    return [...workspace];
  const result = [...workspace];
  const [item] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, item!);
  return result;
}

export function moveOrderWordToSlot(
  workspace: readonly OrderWordItem[],
  fromIndex: number,
  slotIndex: number,
): OrderWordItem[] {
  if (fromIndex < 0 || fromIndex >= workspace.length) return [...workspace];
  const result = [...workspace];
  const [item] = result.splice(fromIndex, 1);
  const target = slotIndex > fromIndex ? slotIndex - 1 : slotIndex;
  result.splice(Math.max(0, Math.min(target, result.length)), 0, item!);
  return result;
}
